/**
 * @param state
 * @returns {*|string}
 */
export function quote(state) {
    return state.quote;
}